export function SetSessionValue(key, value) {
  sessionStorage.setItem(key, JSON.stringify(value));
}

export function GetSessionValue(key) {
  return JSON.parse(sessionStorage.getItem(key));
}

export default SetSessionValue;
